import { useEffect, useState } from "react";
import Business_Loan_App from "../applications/Business_Loan_App";
import {
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Center,
    Text,
    Box,
    TableContainer,
    HStack,
} from "@chakra-ui/react";

import SearchBar from "../SearchBar";
import useAPI from "../../hooks/useAPI";
import CustomSpinner from "../CustomSpinner";
import NavBar from "../Navbar";

function BusinessLoan() {
    const [query, setQuery] = useState("");
    const [allData, setAllData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);

    const { data, error, loading } = useAPI("/business_loan");
    console.log("Business Loan Data", data);

    useEffect(() => {
        if (data) {
            setAllData(data);
            setFilteredData(data);
        }
    }, [data]);

    const handleSearch = (input) => {
        setQuery(input);
        const lowerInput = input.toLowerCase();

        const filtered = allData.filter((item) =>
            item.name?.toLowerCase().includes(lowerInput)
        );

        setFilteredData(filtered);
    };

    return (
        <>
            <NavBar activeName={"Business Loan"} />
            <Center my={2}></Center>
            <HStack spacing={4} mb={4}>
                <SearchBar
                    onSearch={handleSearch}
                    placeholder={"Search by name"}
                />
            </HStack>

            <TableContainer
                borderRadius="xl"
                whiteSpace="normal"
                height="625px"
                overflowY="auto"
                position="relative"
            >
                <Table size="sm">
                    <Thead position="sticky" top="0" zIndex={1}>
                        <Tr>
                            <Th>ID</Th>
                            <Th>Date Applied</Th>
                            <Th>Name</Th>
                            <Th>Business Name</Th>
                            <Th>Loan Amount</Th>
                            <Th>Loan Status</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {!loading &&
                            filteredData.map((item, index) => {
                                const { id, ...rest } = item;
                                return (
                                    <Business_Loan_App key={index} loan_id={id} {...rest} />
                                );
                            })}
                    </Tbody>

                </Table>


                {loading && <CustomSpinner />}
                {!loading && filteredData.length === 0 && (
                    <Box
                        width={"100%"}
                        height={"100%"}
                        display={"flex"}
                        justifyContent={"center"}
                        alignItems={"center"}
                        position={"absolute"}
                        top={0}
                    >
                        <Text fontSize="2xl" fontWeight="semibold" color="gray.500">
                            No Business Loan Applications
                        </Text>
                    </Box>
                )}
            </TableContainer>
        </>
    );
}

export default BusinessLoan;
